import { shallowEqual } from 'react-redux';

import { NsCard } from 'components/common/ns-card/NsCard';
import { NsContent } from 'components/common/ns-content/NsContent';
import { NsDescriptionList } from 'components/common/ns-description-list/NsDescriptionList';
import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';

import { useNavigation } from 'hooks/useNavigation';
import { useAppSelector } from 'hooks/useAppSelector';

import { selectHasPsr } from 'state/psr/psr-slice';

export const OrderSummaryPsrDetails = () => {
  const hasPsr = useAppSelector(selectHasPsr, shallowEqual);
  const { eventTypes, next } = useNavigation();

  const psrDescription = hasPsr
    ? 'Yes, extra support required'
    : 'No, extra support not required';

  const changePsrDetails = () => {
    next({ eventType: eventTypes.CHANGE_PERSONAL_DETAILS, wasVisited: true });
  };

  return (
    <>
      <NsContent spacing="normal">
        <h2 className="h4">Extra support and priority services</h2>
      </NsContent>

      <NsCard>
        <NsDescriptionList>
          {[
            {
              term: 'Priority Services Register',
              description: [
                <>{psrDescription}</>,
                <>
                  <br />
                  <NsSecondaryCta onClick={changePsrDetails} icon="">
                    Edit Priority Services Register
                  </NsSecondaryCta>
                </>
              ]
            }
          ]}
        </NsDescriptionList>
      </NsCard>
    </>
  );
};

export default OrderSummaryPsrDetails;
